<template>
  <div v-if="visible" class="wechat_auth_tips">
    <p>诺亚荣耀保险经纪联合保险师共同为您提供计划书服务</p>
    <i class="iconfont icon-close_line" @click="onClose" />
  </div>
</template>
<script>
import Jax from '@bxs/jax'
import { APP_CHANNEL } from '@/common/utils/variables'
export default {
  data () {
    return {
      visible: Jax.isWeChat() && APP_CHANNEL === 'NUOYA'
    }
  },
  mounted () {
    setTimeout(() => {
      this.visible = false
    }, 15000)
  },
  methods: {
    onClose () {
      this.visible = false
    }
  }
}
</script>
<style lang="less">
.wechat_auth_tips {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 10px 15px;
  background: #FFF9EC;
  z-index: 1000;
  & > p {
    color: #666;
    font-size: 12px;
  }
  & > i {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
  }
}
</style>